const textArea = document.querySelectorAll('.mod-input textarea');

textArea.forEach((textarea) => {
  const parentElement = textarea.closest('.mod-input');
  textarea.addEventListener('input', (input) => {
    const characterCountElement = parentElement.querySelector('.mod-input__curr-character');
    const maxLength = input.target.getAttribute('maxlength');
    const inputValueLength = input.target.value.length;
    characterCountElement.textContent = `${inputValueLength}`;
    parentElement.classList.toggle('max-length-reached', inputValueLength === parseInt(maxLength));
  });
});
